import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges} from '@angular/core';


import { KeySelectItem } from '@core/models/select-item.model';

import { AvailableRuleActionVariableValueItem } from '@app/models/rules';

@Component({
  selector: 'settings-rules-rule-form-helper-select',
  templateUrl: './helper-select.component.html',
  styleUrls: ['./helper-select.component.scss'],
})
export class SettingsRulesFormHelperSelectComponent implements OnInit, OnChanges {

    @Input() disabled: boolean;
    @Input() optionSelected: string = null;
    @Input() label: string = "";
    @Input() options: AvailableRuleActionVariableValueItem[] = [];
    @Input() placeholder: string;
    @Output() actionSelect = new EventEmitter<AvailableRuleActionVariableValueItem>();

    public items: Array<KeySelectItem> = [];

    ngOnInit() {
        this.init();
    }

    ngOnChanges(changes: SimpleChanges){
        if(changes.options) {
            this.init();
        }
        if(changes.optionSelected){
            this.init();
        }
    }

    protected init() {
        this.items = this.options.map((o: AvailableRuleActionVariableValueItem) => ({...o,
            selected: this.optionSelected.toString() == o.key.toString(),
            key: o.key.toString(),
            disabled: o.options?.hasOwnProperty('selectable') ? !o.options.selectable : false
        }));
    }

    onSelectItem(item: KeySelectItem) {  
        let option = this.options.filter((o: AvailableRuleActionVariableValueItem)=> o.key == item.key);

        this.actionSelect.emit(option[0]);
    }
}
